var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "", "justify-space-around": "" } },
        [
          _c("v-flex", { attrs: { xs2: "" } }),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs3: "" } },
            [
              !_vm.disabled
                ? _c("wz-avatar", {
                    attrs: {
                      src: _vm.imageSrc,
                      tile: _vm.tile,
                      username: _vm.$store.getters["_User/fullName"],
                      size: "128px"
                    }
                  })
                : _c("v-progress-circular", {
                    staticClass: "primary--text",
                    attrs: { indeterminate: "", size: 128, width: 1 }
                  })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-flex", { attrs: { xs2: "" } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", "justify-space-around": "" } },
        [
          _c("v-flex", { attrs: { xs1: "" } }),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs10: "" } },
            [
              _c("wz-file-selector", {
                attrs: { value: _vm.textFieldValue, disabled: _vm.disabled },
                on: { change: _vm.previewThumbnail }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-flex", { attrs: { xs1: "" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-94360ec0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94360ec0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzImgUpload.vue
// module id = null
// module chunks = 